import TTask from '../types/Task';
import connectGetter from './connectGetter';

type AttributesSource =
  | {
      task?: Partial<TTask>;
    }
  | {
      attributes: connect.AttributeDictionary;
    }
  | {
      contact?: connect.Contact;
    };

type ContactAttributes<T extends string> = Record<T, string | undefined>;

function getAttributeValues<T extends string>(
  attributeNames: string[],
  attributes: connect.AttributeDictionary = {}
): ContactAttributes<T> {
  return attributeNames.reduce(
    (attributeValues, attributeName) => ({
      ...attributeValues,
      [attributeName]: attributes?.[attributeName]?.value,
    }),
    {} as ContactAttributes<T>
  );
}

export default function getContactAttributes<T extends string>(
  attributesSource: AttributesSource,
  ...attributeNames: T[]
): ContactAttributes<T> {
  if ('attributes' in attributesSource) {
    return getAttributeValues(attributeNames, attributesSource.attributes);
  }

  if ('contact' in attributesSource) {
    return attributesSource.contact
      ? getAttributeValues(attributeNames, connectGetter(attributesSource.contact, 'getAttributes'))
      : ({} as ContactAttributes<T>);
  }

  if ('task' in attributesSource && attributesSource.task?.contact) {
    return attributesSource.task?.contact
      ? getAttributeValues(attributeNames, connectGetter(attributesSource.task.contact, 'getAttributes'))
      : ({} as ContactAttributes<T>);
  }

  return {} as ContactAttributes<T>;
}
